import { createContext } from 'use-context-selector';
import { type EntityMentionContext } from './types';

const EntityMentionContextProvider = createContext<
    EntityMentionContext | undefined
>(undefined);

export default EntityMentionContextProvider;
